import {
    PROJECTS_CRUD_RESTORE_STATE,
    SET_PIPE_RISER,
    SET_PIPE_INVERT,
    SET_PIPE_CLEANOUT,
    SET_PIPE_INSERTA_TEE,
    PIPE_SET_PITCH,
    PIPE_SET_MANIFOLD_T,
    PIPE_SET_MANIFOLD_CORNER,
    PIPE_SET_BED_DIMENSIONS,
    PIPE_SET_ACCESORY,
    PIPE_REMOVE_ACCESORY,
    PIPE_SET_BED_POSITION,
    PIPE_SET_BED_TRANSFORMATION,
    PIPE_SET_BED_CENTRALICED_COORDINATES,
    APPTOOLBAR_RESET_APP_STATE,
    PIPE_RESET_ACCESSORIES,
    SUB_PROJECTS_CRUD_RESTORE_STATE,
    MULTIBED_RESET_APP_STATE,
    APPTOOLBAR_BASIC_RESET_APP_STATE,
} from "../lib/types";
import _ from "lodash";
import PipeRiser, { PipeRiserUtility } from '../lib/Pipes/PipeAccessories/pipe-riser';
import PipeInvert, { PipeInvertUtility } from '../lib/Pipes/PipeAccessories/pipe-invert';
import PipeCleanout, { PipeCleanoutUtility } from '../lib/Pipes/PipeAccessories/pipe-cleanout';
import PipeInsertaTee, { PipeInsertaTeeUtility } from '../lib/Pipes/PipeAccessories/pipe-insertaTee';
import PipeElement from "../lib/pipe-element";
import { InchUtility } from "../lib/pipe-dataset";

const initialState = {
    pipeRiser: PipeRiser.TYPE._M,
    pipeInvert: PipeInvert.TYPE._M,
    pipeCleanout: PipeCleanout.TYPE._M,
    pipeInsertaTee: PipeInsertaTee.TYPE._M,
    units: 'ft',
    numberOfPipeRows: 0,
    numberOfPipeSticks: 0,
    numberOfManifoldTees: 0,
    numberOfManifoldCorners: 0,
    rotation: 0,
    position: {
        x: 150,
        y: 150
    },
    dimensions: {
        width: new InchUtility(7.5 * 12),
        length: new InchUtility(15 * 12)
    },
    stoneBedDimensions: {
        x: 0,
        y: 0,
        width: new InchUtility(0),
        length: new InchUtility(0)
    },
    pipeBedDimensions: {
        x: 0,
        y: 0,
        width: new InchUtility(0),
        length: new InchUtility(0)
    },
    centerFittingDimensions: {
        x: 0,
        y: 0,
        width: new InchUtility(0),
        length: new InchUtility(0)
    },
    rowBedDimensions: {
        x: 0,
        y: 0,
        width: new InchUtility(0),
        length: new InchUtility(0)
    },
    area: 0,
    volume: 0,
    pipeElements: [],
    manifoldTeeDistribution: {
        triples: 3,
        doubles: 1,
        singles: 0
    },
    rowLength: new InchUtility(0),
    rowPipeStickCutLength: new InchUtility(0),
    numberOfMaxLengthPipeSticksPerRow: 0,
    numberOfCutLengthPipeSticksPerRow: 0,
    stoneBedVolume: 0,
    pipeBedVolume: 0
};

const getManifoldDistribution = ( numberOfRows, pipeNominalDiameter ) => {
    let coveredRows = 0;

    if (numberOfRows <= 2) {
        //if only corners, or single...
        return {triples: 0, doubles: 0, singles: 0}
    }
    numberOfRows -= numberOfRows > 2 ? 2 : 0;

    let triples = 0;

    if (pipeNominalDiameter.rawPipeND <= 36) {
        // Check for nominal diameter
        triples = Math.floor((numberOfRows / 3));
        triples = triples > 0 ? triples : 0;
        coveredRows = coveredRows + (triples * 3);
    }

    let doubles = Math.floor(((numberOfRows - coveredRows) / 2));
    doubles = doubles > 0 ? doubles : 0;
    coveredRows = coveredRows + (doubles * 2);

    let singles = numberOfRows - coveredRows;
    singles = singles > 0 ? singles : 0;

    return {
        triples: triples,
        doubles: doubles,
        singles: singles
    }
};

/**
 *
 * @param {Object} state
 * @param {Object} payload
 * @param {Boolean} isRemoving
 */
const manipulateAccessory = ( state, payload, isRemoving ) => {
    /* cloning the array */
    let pipeElementsClone = state.pipeElements.slice();

    /* search the element for the accessory to be edited */
    let element = pipeElementsClone.find(( e ) => {
        return _.isEqual(e.id, payload.id);
    });
    /* if not found, add to collection */
    if (!element) {
        element = new PipeElement(payload.id, payload.id.type);
        pipeElementsClone.push(element);
    }
    /* clone accessory */
    element = element.clone();
    /* removing or adding accessory */
    if (isRemoving) {
        element.detachAccessory(
            payload.position,
            payload.placement
        );
    } else {
        element.attachAccessory(
            payload.position,
            payload.placement,
            payload.type,
            payload.size
        );
    }
    /* replace the cloned element and return collection */
    return pipeElementsClone.map(( e ) => {
        /* clone if statement */
        if (_.isEqual(e.id, element.id)) {
            return element;
        } else {
            return e;
        }
    });
};

export let PipeBedReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case PIPE_SET_BED_TRANSFORMATION:
            return {
                ...state,
                position: {
                    x: action.payload.x,
                    y: action.payload.y
                },
                rotation: action.payload.rotation
            };

        case PIPE_SET_BED_CENTRALICED_COORDINATES:
            initialState.position.x = action.payload.x;
            initialState.position.y = action.payload.y;
            return {
                ...state,
                position: {
                    x: action.payload.x,
                    y: action.payload.y
                }
            };

        case PIPE_SET_PITCH:
            return {
                ...state,
                pitch: action.payload
            };

        case PIPE_SET_MANIFOLD_T:
            return {
                ...state,
                manifoldT: action.payload
            };

        case PIPE_SET_MANIFOLD_CORNER:
            return {
                ...state,
                manifoldCorner: action.payload
            };

        case SET_PIPE_RISER:
            return {
                ...state,
                pipeRiser: action.payload,
            };

        case SET_PIPE_INVERT:
            return {
                ...state,
                pipeInvert: action.payload,
            };

        case SET_PIPE_CLEANOUT:
            return {
                ...state,
                pipeCleanout: action.payload,
            };

        case SET_PIPE_INSERTA_TEE:
            return {
                ...state,
                pipeInsertaTee: action.payload,
            };

        case PIPE_RESET_ACCESSORIES:
            return {
                ...state,
                pipeElements: []
            };

        case PIPE_SET_ACCESORY:
            return {
                ...state,
                pipeElements: manipulateAccessory(state, action.payload, false)
            };

        case PIPE_REMOVE_ACCESORY:
            return {
                ...state,
                pipeElements: manipulateAccessory(state, action.payload, true)
            };

        case PIPE_SET_BED_DIMENSIONS:
            const {pipeNominalDiameter} = action.payload.state.pipeGlobals;

            return {
                ...state,
                area: action.payload.area,
                volume: action.payload.volume,
                rowLength: action.payload.rowLength,
                rowSpacing: action.payload.rowSpacing,
                dimensions: {...action.payload.dimensions},
                pipeBedVolume: action.payload.pipeBedVolume,
                stoneBedVolume: action.payload.stoneBedVolume,
                numberOfPipeRows: action.payload.numberOfPipeRows,
                numberOfPipeSticks: action.payload.numberOfPipeSticks,
                rowBedDimensions: {...action.payload.rowBedDimensions},
                pipeBedDimensions: {...action.payload.pipeBedDimensions},
                numberOfManifoldTees: action.payload.numberOfManifoldTees,
                stoneBedDimensions: {...action.payload.stoneBedDimensions},
                rowPipeStickCutLength: action.payload.rowPipeStickCutLength,
                numberOfManifoldTeesPerRow: action.payload.numberOfManifoldTees / 2,
                centerFittingDimensions: {...action.payload.centerFittingDimensions},
                numberOfMaxLengthPipeSticksPerRow: action.payload.numberOfMaxLengthPipeSticksPerRow,
                numberOfCutLengthPipeSticksPerRow: action.payload.numberOfCutLengthPipeSticksPerRow,
                manifoldTeeDistribution: getManifoldDistribution(action.payload.numberOfPipeRows, pipeNominalDiameter),
            };

        case PIPE_SET_BED_POSITION:
            return {
                ...state,
                position: action.payload
            };

        case APPTOOLBAR_BASIC_RESET_APP_STATE:
        case MULTIBED_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        case SUB_PROJECTS_CRUD_RESTORE_STATE:
        case PROJECTS_CRUD_RESTORE_STATE:
            /* receive the new state */
            let rState = action.payload.pipeBed;
            /* if no pipe state present, return default state */
            if (!rState
                || !rState.pipeBedDimensions
                || !rState.pipeBedDimensions.height
                || !rState.pipeBedDimensions.width
                || !rState.stoneBedDimensions
                || !rState.stoneBedDimensions.height
                || !rState.stoneBedDimensions.width
                || !rState.pipeRiser
                || !rState.pipeInvert
                || !rState.pipeCleanout
                || !rState.pipeInsertaTee
                || !rState.dimensions
                || !rState.dimensions.width
                || !rState.dimensions.length
                || !rState.pipeElements
                || !rState.rowLength
                || !rState.rowPipeStickCutLength
            ) {
                console.warn("WARNING: some pipe bed properties are null or undefined (PIPE BED REDUCER");
                return state;
            }

            const getProjectDimensions = key => {
                let initialDimensions = {
                    x: new InchUtility(0),
                    y: new InchUtility(0),
                    width: new InchUtility(0),
                    height: new InchUtility(0)
                };

                if (rState[key] === undefined) {
                    return {...initialDimensions};
                }

                const dimensions = rState[key];

                return {
                    x: new InchUtility(dimensions.x._inches),
                    y: new InchUtility(dimensions.y._inches),
                    width: new InchUtility(dimensions.width._inches),
                    height: new InchUtility(dimensions.height._inches)
                };
            };

            /* deserialize state */
            rState = {
                ...rState,
                pipeRiser: {
                    ...rState.pipeRiser,
                    od: new PipeRiserUtility(rState.pipeRiser.od.inches),
                    width: new PipeRiserUtility(rState.pipeRiser.width.inches),
                    length: new PipeRiserUtility(rState.pipeRiser.length.inches),
                },
                pipeInvert: {
                    ...rState.pipeInvert,
                    od: new PipeInvertUtility(rState.pipeInvert.od.inches),
                    width: new PipeInvertUtility(rState.pipeInvert.width.inches),
                    length: new PipeInvertUtility(rState.pipeInvert.length.inches),
                },
                pipeCleanout: {
                    ...rState.pipeCleanout,
                    od: new PipeCleanoutUtility(rState.pipeCleanout.od.inches),
                    width: new PipeCleanoutUtility(rState.pipeCleanout.width.inches),
                    length: new PipeCleanoutUtility(rState.pipeCleanout.length.inches),
                },
                pipeInsertaTee: {
                    ...rState.pipeInsertaTee,
                    od: new PipeInsertaTeeUtility(rState.pipeInsertaTee.od.inches),
                    width: new PipeInsertaTeeUtility(rState.pipeInsertaTee.width.inches),
                    length: new PipeInsertaTeeUtility(rState.pipeInsertaTee.length.inches),
                },
                dimensions: {
                    width: new InchUtility(rState.dimensions.width._inches),
                    length: new InchUtility(rState.dimensions.length._inches)
                },
                stoneBedDimensions: getProjectDimensions("stoneBedDimensions"),
                pipeBedDimensions: getProjectDimensions("pipeBedDimensions"),
                rowBedDimensions: getProjectDimensions("rowBedDimensions"),
                centerFittingDimensions: getProjectDimensions("centerFittingDimensions"),
                pipeElements: rState.pipeElements.map(( e ) => {
                    return new PipeElement(e.id, e.type, e.placeholders);
                }),
                rowLength: new InchUtility(rState.rowLength._inches),
                rowPipeStickCutLength: new InchUtility(rState.rowPipeStickCutLength._inches)
            };
            /* todo transformation logic here */
            return rState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/pipe-bed-reducer.js